module.exports = __webpack_public_path__ + "img/arrow9.ee5f7bfc.svg";